import { ContentsModuleType } from 'types';

export const isImageContentsModuleType = (
  type: ContentsModuleType,
): type is ContentsModuleType => {
  return type === 'SUB_IMAGE' || type === 'MAIN_IMAGE';
};
